<template>
	<section class="margin-both-lg container margin-auto">
		<div class="inner padding-lg">
			<h2 class="module-title">{{ data.module_title }}</h2>
			<div class="description" v-html="data.description"></div>
			<div class="button-group" v-if="data && data.links && data.links.length">
				<ColorLink
					v-for="({ link, color }, k) in data.links"
					:link="link"
					uppercase
					:color="color"
					:outlined="color === 'black'"
					:key="k"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import ColorLink from '@/components/elements/ColorLink'

export default {
	props: ['data'],
	computed: {},
	components: {
		ColorLink,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.dark-theme {
	.module-cta_black {
		.inner {
			background-color: var(--gray);
		}
		.module-title,
		.description {
			color: var(--dark);
		}
	}
}
.module-cta_black {
	.button-group {
		margin-top: 25px;
		margin-left: -10px;
		margin-right: -10px;
		@include mquery($phone) {
			margin-left: 0;
			margin-right: 0;
		}
		.fill-button {
			margin-left: 10px;
			margin-right: 10px;
			@include mquery($phone) {
				margin-top: 20px;
				display: block;
				width: 100%;
				margin-left: 0px;
				margin-right: 0px;
			}
		}
	}
	.inner {
		background-color: var(--dark);
	}
	.module-title,
	.description {
		color: var(--light);
	}
	.module-title {
		margin-top: 0;
		margin-bottom: 25px;
		@include mquery($tablet) {
			margin-bottom: 20px;
		}
	}
}
</style>
